import { lazy } from "react";
import { RouteObject } from "react-router-dom";

import { buildClassEnrollUrl } from "@/scheduling/components/ClassEventEnroll/utils";

const CalendarAppointmentManager = lazy(
  () => import("@/scheduling/components/CalendarAppointmentManager"),
);
const AppointmentScheduler = lazy(
  () => import("@/scheduling/components/CalendarAppointmentManager/AppointmentScheduler"),
);
const AppointmentConfirmation = lazy(
  () =>
    import(
      "@/scheduling/components/CalendarAppointmentManager/AppointmentConfirmation/AppointmentConfirmation"
    ),
);

const RescheduleManager = lazy(
  () => import("@/scheduling/components/Rescheduling/RescheduleManager/RescheduleManager"),
);

const AppointmentRescheduler = lazy(
  () =>
    import("@/scheduling/components/Rescheduling/AppointmentRescheduler/AppointmentRescheduler"),
);
const ClassEventEnrollOverview = lazy(
  () => import("@/scheduling/components/ClassEventEnroll/ClassEventEnrollOverview"),
);
const ClassEventEnrollForm = lazy(
  () => import("@/scheduling/components/ClassEventEnroll/ClassEventEnrollForm"),
);
const ClassEventEnrollConfirmation = lazy(
  () => import("@/scheduling/components/ClassEventEnroll/ClassEventEnrollConfirmation"),
);
const ClassEventPublicEnrollPage = lazy(
  () => import("@/scheduling/components/ClassEventEnroll/ClassEventPublicEnrollPage.tsx"),
);

export const ScheduleRoutes: RouteObject[] = [
  {
    path: "/schedule/client/:communicationRequestID/appointment/overview",
    element: <CalendarAppointmentManager />,
  },
  {
    path: "/schedule/client/:communicationRequestID/appointment/form",
    element: <AppointmentScheduler />,
  },
  {
    path: "/schedule/client/:communicationRequestID/appointment/confirmation",
    element: <AppointmentConfirmation />,
  },
  {
    path: "/schedule/:practiceId/reschedule/:appointmentId",
    element: <RescheduleManager />,
  },
  {
    path: "/schedule/:practiceId/reschedule/:appointmentId/form",
    element: <AppointmentRescheduler />,
  },
  {
    path: "/schedule/:practiceId/reschedule/:appointmentId/confirmation",
    element: <AppointmentConfirmation />,
  },
  {
    path: buildClassEnrollUrl(":practiceId", ":scheduleId", ":classId"),
    element: <ClassEventPublicEnrollPage />,
  },
  {
    path: "/schedule/client/:practiceId/calendar/:scheduleId/class/:classId/enroll/:patientId/overview",
    element: <ClassEventEnrollOverview />,
  },
  {
    path: "/schedule/client/:practiceId/calendar/:scheduleId/class/:classId/enroll/:patientId/form",
    element: <ClassEventEnrollForm />,
  },
  {
    path: "/schedule/client/:practiceId/calendar/:scheduleId/class/:classId/enroll/:patientId/confirmation",
    element: <ClassEventEnrollConfirmation />,
  },
];
